<template>
  <div>
    <h2 class="text-center">API Demo Quota</h2>
    <p class="text-center">
      총 <strong>{{ institutionQuotas.length }}</strong>개 API Demo Quota
    </p>

    <!-- Pending Approvals Section -->
    <div v-if="pendingQuotas.length > 0" class="mb-4">
      <h5 class="text-center text-warning">
        <i class="fa fa-clock-o"></i> 승인 대기 ({{ pendingQuotas.length }})
      </h5>
      <div class="table-responsive-wrapper">
        <table class="table table-hover table-sm">
          <thead>
            <tr>
              <th>소유자</th>
              <th>기관</th>
              <th>요청일</th>
              <th class="text-center">승인</th>
              <th class="text-center">거부</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="pq in pendingQuotas" :key="'pending-' + pq.id">
              <td>{{ pq.owner }}</td>
              <td>{{ pq.institution }}</td>
              <td>{{ pq.created_at ? pq.created_at.split('T')[0] : 'N/A' }}</td>
              <td class="text-center">
                <button class="btn btn-success btn-sm" @click="approveQuota(pq)">
                  <i class="fa fa-check"></i> Approve
                </button>
              </td>
              <td class="text-center">
                <button class="btn btn-danger btn-sm" data-toggle="modal" data-target="#rejectQuotaModal" @click="rejectQuota(pq)">
                  <i class="fa fa-times"></i> Reject
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <hr />
    </div>

    <div class="row justify-content-md-center">
      <div class="col-md-auto btn-group" role="group" style="padding-bottom: 20px">
        <button type="button" class="btn btn-secondary" @click="loadAll">
          새로고침
        </button>
      </div>
    </div>

    <div class="row justify-content-md-center" style="padding-bottom: 10px">
      <div class="col-md-3">
        <input
          v-model="quotaFilter.username"
          class="form-control form-control-sm"
          placeholder="사용자 ID로 검색"
          @input="loadInstitutionQuotas"
        />
      </div>
      <div class="col-md-3">
        <input
          v-model="quotaFilter.institution"
          class="form-control form-control-sm"
          placeholder="Institution으로 검색"
          @input="loadInstitutionQuotas"
        />
      </div>
      <div class="col-md-2">
        <select
          v-model="quotaFilter.status"
          class="form-control form-control-sm"
          @change="loadInstitutionQuotas"
        >
          <option value="">전체 상태</option>
          <option value="active">Active</option>
          <option value="pending">Pending</option>
          <option value="rejected">Rejected</option>
        </select>
      </div>
    </div>

    <div v-if="quotasByOwner.length === 0" class="text-center text-muted py-3">
      API Demo Quota가 없습니다
    </div>

    <div v-for="group in quotasByOwner" :key="group.owner">
      <b-card no-body class="mb-2">
        <b-card-header
          class="d-flex justify-content-between align-items-center"
          style="cursor: pointer;"
          @click="toggleOwner(group.owner)"
        >
          <span>
            <strong>{{ group.ownerName }}</strong>
            <small v-if="group.ownerName !== group.owner" class="text-muted ml-1">({{ group.owner }})</small>
            <span class="badge badge-secondary ml-2">{{ group.activeQuotas.length }}</span>
            <span v-if="group.inactiveQuotas.length > 0" class="text-muted ml-1">(+{{ group.inactiveQuotas.length }} 만료/거부)</span>
          </span>
          <i :class="openOwners[group.owner] ? 'fa fa-chevron-up' : 'fa fa-chevron-down'" />
        </b-card-header>
        <b-collapse :visible="openOwners[group.owner] || false">
          <b-card-body class="p-0">
            <div class="table-responsive-wrapper">
              <table class="table table-hover table-sm mb-0">
                <thead class="remove-top-border">
                  <tr>
                    <th scope="col">기관</th>
                    <th scope="col">한도</th>
                    <th scope="col">사용</th>
                    <th scope="col">잔여</th>
                    <th scope="col">생성일</th>
                    <th scope="col">만료일</th>
                    <th scope="col">상태</th>
                    <th class="text-center" scope="col">편집</th>
                    <th class="text-center" scope="col">초기화</th>
                    <th class="text-center" scope="col">활성/비활성</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="quota in group.activeQuotas" :key="quota.id">
                    <td>{{ quota.institution }}</td>
                    <td>{{ quota.limit }}</td>
                    <td>{{ quota.used }}</td>
                    <td>{{ quota.remaining }}</td>
                    <td>{{ quota.created_at ? quota.created_at.split('T')[0] : 'N/A' }}</td>
                    <td>{{ quota.expires_at ? quota.expires_at.split('T')[0] : 'N/A' }}</td>
                    <td>
                      <span v-if="quota.status === 'active'" class="badge badge-success">Active</span>
                      <span v-else-if="quota.status === 'pending'" class="badge badge-warning">Pending</span>
                      <span v-else-if="quota.status === 'rejected'" class="badge badge-danger">Rejected</span>
                      <span v-else-if="quota.status === 'exhausted'" class="badge badge-danger">Exhausted</span>
                      <span v-else-if="quota.status === 'expired'" class="badge badge-warning">Expired</span>
                      <span v-else-if="quota.status === 'blocked'" class="badge badge-dark">Blocked</span>
                      <span v-else class="badge badge-secondary">{{ quota.status }}</span>
                    </td>
                    <td class="text-center">
                      <i
                        class="fa fa-pencil"
                        data-toggle="modal"
                        data-target="#editQuotaModal"
                        @click="setEditQuota(quota)"
                        title="할당량 편집"
                      />
                    </td>
                    <td class="text-center">
                      <i
                        class="fa fa-refresh"
                        style="color: #dc3545;"
                        @click="resetQuotaUsed(quota)"
                        title="사용량 초기화"
                      />
                    </td>
                    <td class="text-center">
                      <i
                        v-if="quota.status === 'active'"
                        class="fa fa-toggle-on text-success"
                        style="font-size: 1.2em; cursor: pointer;"
                        @click="toggleQuotaActive(quota)"
                        title="비활성화"
                      />
                      <i
                        v-else-if="quota.status === 'exhausted' || quota.status === 'pending'"
                        class="fa fa-toggle-off text-muted"
                        style="font-size: 1.2em; cursor: not-allowed; opacity: 0.5;"
                        :title="quota.status === 'exhausted' ? '한도 소진 — 토글 불가' : '승인 대기 — 토글 불가'"
                      />
                      <i
                        v-else
                        class="fa fa-toggle-off text-muted"
                        style="font-size: 1.2em; cursor: pointer;"
                        @click="toggleQuotaActive(quota)"
                        title="활성화"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-card-body>
          <!-- 비활성(만료/거부) quota 아코디언 -->
          <div v-if="group.inactiveQuotas.length > 0" class="px-3 pb-2">
            <small
              class="text-muted d-block mt-2 mb-1"
              style="cursor: pointer;"
              @click="toggleInactiveOwner(group.owner)"
            >
              <i class="fa" :class="openInactiveOwners[group.owner] ? 'fa-chevron-up' : 'fa-chevron-down'" />
              만료/거부 ({{ group.inactiveQuotas.length }}개)
            </small>
            <b-collapse :visible="openInactiveOwners[group.owner] || false">
              <div class="table-responsive-wrapper">
                <table class="table table-hover table-sm mb-0" style="opacity: 0.7;">
                  <thead class="remove-top-border">
                    <tr>
                      <th scope="col">기관</th>
                      <th scope="col">한도</th>
                      <th scope="col">사용</th>
                      <th scope="col">잔여</th>
                      <th scope="col">생성일</th>
                      <th scope="col">만료일</th>
                      <th scope="col">상태</th>
                      <th scope="col">거절 사유</th>
                      <th class="text-center" scope="col">편집</th>
                      <th class="text-center" scope="col">초기화</th>
                      <th class="text-center" scope="col">활성/비활성</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="quota in group.inactiveQuotas" :key="'inactive-' + quota.id">
                      <td>{{ quota.institution }}</td>
                      <td>{{ quota.limit }}</td>
                      <td>{{ quota.used }}</td>
                      <td>{{ quota.remaining }}</td>
                      <td>{{ quota.created_at ? quota.created_at.split('T')[0] : 'N/A' }}</td>
                      <td>{{ quota.expires_at ? quota.expires_at.split('T')[0] : 'N/A' }}</td>
                      <td>
                        <span v-if="quota.status === 'expired'" class="badge badge-warning">Expired</span>
                        <span v-else-if="quota.status === 'rejected'" class="badge badge-danger">Rejected</span>
                        <span v-else-if="quota.status === 'blocked'" class="badge badge-dark">Blocked</span>
                      </td>
                      <td>
                        <span v-if="quota.rejection_reason" :title="quota.rejection_reason" class="rejection-reason-text">
                          {{ quota.rejection_reason }}
                        </span>
                        <span v-else class="text-muted">-</span>
                        <i
                          v-if="quota.status === 'rejected'"
                          class="fa fa-pencil ml-1"
                          style="font-size: 12px;"
                          data-toggle="modal"
                          data-target="#editReasonModal"
                          @click="openEditReasonModal(quota)"
                          title="거절 사유 수정"
                        />
                      </td>
                      <td class="text-center">
                        <i class="fa fa-pencil" data-toggle="modal" data-target="#editQuotaModal" @click="setEditQuota(quota)" title="할당량 편집" />
                      </td>
                      <td class="text-center">
                        <i class="fa fa-refresh" style="color: #dc3545;" @click="resetQuotaUsed(quota)" title="사용량 초기화" />
                      </td>
                      <td class="text-center">
                        <i class="fa fa-toggle-off text-muted" style="font-size: 1.2em; cursor: not-allowed; opacity: 0.5;" :title="quota.status === 'expired' ? '만료됨' : quota.status === 'rejected' ? '거부됨' : '비활성'" />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </b-collapse>
          </div>
        </b-collapse>
      </b-card>
    </div>

    <!-- editQuota Modal -->
    <div class="modal fade" tabindex="-1" role="dialog" id="editQuotaModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">API Demo Quota 편집</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              id="closeEditQuota"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group">
                <label>Institution</label>
                <input
                  v-model="editQuota.institution"
                  class="form-control"
                  readonly
                />
              </div>
              <div class="form-group">
                <label>Owner</label>
                <input
                  v-model="editQuota.owner"
                  class="form-control"
                  readonly
                />
              </div>
              <div class="form-group">
                <label>현재 사용량</label>
                <input
                  :value="editQuota.used + ' / ' + editQuota.currentLimit"
                  class="form-control"
                  readonly
                />
              </div>
              <div class="form-group">
                <label>새 Limit</label>
                <input
                  v-model.number="editQuota.limit"
                  type="number"
                  min="0"
                  class="form-control"
                  placeholder="할당량 한도"
                  required
                />
              </div>
              <div class="form-group">
                <label>만료일</label>
                <input
                  v-model="editQuota.expiresAt"
                  type="date"
                  class="form-control"
                  required
                />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn btn-primary" @click="updateQuota">
              저장
            </button>
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- rejectQuota Modal -->
    <div class="modal fade" tabindex="-1" role="dialog" id="rejectQuotaModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Quota 거부</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeRejectQuota">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Institution</label>
              <input :value="rejectForm.institution" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label>Owner</label>
              <input :value="rejectForm.owner" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label>거절 사유 프리셋</label>
              <div>
                <button
                  v-for="preset in rejectPresets"
                  :key="preset.label"
                  type="button"
                  class="btn btn-sm btn-outline-secondary mr-1 mb-1"
                  @click="setRejectPreset(preset)"
                >
                  {{ preset.label }}
                </button>
              </div>
            </div>
            <div class="form-group">
              <label>거절 사유</label>
              <textarea
                v-model="rejectForm.reason"
                class="form-control"
                rows="3"
                maxlength="500"
                placeholder="거절 사유를 입력하세요 (미입력 시 기본 메시지 사용)"
              ></textarea>
              <small class="text-muted">{{ (rejectForm.reason || '').length }} / 500</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger" @click="confirmReject">
              거부
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- editReason Modal -->
    <div class="modal fade" tabindex="-1" role="dialog" id="editReasonModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">거절 사유 수정</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeEditReason">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Institution</label>
              <input :value="editReasonForm.institution" class="form-control" readonly />
            </div>
            <div class="form-group">
              <label>거절 사유 프리셋</label>
              <div>
                <button
                  v-for="preset in rejectPresets"
                  :key="'edit-' + preset.label"
                  type="button"
                  class="btn btn-sm btn-outline-secondary mr-1 mb-1"
                  @click="editReasonForm.reason = preset.value"
                >
                  {{ preset.label }}
                </button>
              </div>
            </div>
            <div class="form-group">
              <label>거절 사유</label>
              <textarea
                v-model="editReasonForm.reason"
                class="form-control"
                rows="3"
                maxlength="500"
                placeholder="거절 사유를 입력하세요"
              ></textarea>
              <small class="text-muted">{{ (editReasonForm.reason || '').length }} / 500</small>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="saveEditReason">
              저장
            </button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import toastrs from "@/mixins/toastrs";
import axios from "@/libs/axios";

export default {
  name: "InstitutionQuotas",
  mixins: [toastrs],
  data() {
    return {
      institutionQuotas: [],
      pendingQuotas: [],
      quotaFilter: {
        username: "",
        institution: "",
        status: ""
      },
      editQuota: {
        id: "",
        institution: "",
        owner: "",
        limit: 100,
        currentLimit: 100,
        used: 0,
        expiresAt: ""
      },
      openOwners: {},
      openInactiveOwners: {},
      rejectForm: {
        quotaId: '',
        institution: '',
        owner: '',
        reason: ''
      },
      editReasonForm: {
        quotaId: '',
        institution: '',
        reason: ''
      },
      rejectPresets: [
        { label: '기본 거절', value: '요청이 거절되었습니다. 자세한 사항은 담당자에게 문의해주세요.' },
        { label: '기관 정보 부족', value: '기관 정보 부족' },
        { label: '데모 자격 미달', value: '데모 자격 미달' },
        { label: '중복 요청', value: '중복 요청' }
      ]
    };
  },
  computed: {
    quotasByOwner: function() {
      var groups = {};
      for (var i = 0; i < this.institutionQuotas.length; i++) {
        var q = this.institutionQuotas[i];
        var owner = q.owner || 'Unknown';
        if (!groups[owner]) {
          groups[owner] = { owner: owner, ownerName: q.owner_name || owner, quotas: [], activeQuotas: [], inactiveQuotas: [] };
        }
        groups[owner].quotas.push(q);
      }
      // active/inactive 분리
      for (var key in groups) {
        var g = groups[key];
        for (var j = 0; j < g.quotas.length; j++) {
          var quota = g.quotas[j];
          if (quota.status === 'expired' || quota.status === 'rejected' || quota.status === 'blocked') {
            g.inactiveQuotas.push(quota);
          } else {
            g.activeQuotas.push(quota);
          }
        }
      }
      return Object.keys(groups).sort().map(function(k) {
        return groups[k];
      });
    }
  },
  methods: {
    toggleOwner: function(owner) {
      this.$set(this.openOwners, owner, !this.openOwners[owner]);
    },
    toggleInactiveOwner: function(owner) {
      this.$set(this.openInactiveOwners, owner, !this.openInactiveOwners[owner]);
    },
    loadAll: function() {
      this.loadInstitutionQuotas();
      this.loadPendingQuotas();
    },
    loadPendingQuotas: function() {
      axios.get('/api/admin/institution-quotas', { params: { status: 'pending' } })
        .then(function(response) {
          if (response.data.success) {
            this.pendingQuotas = response.data.quotas;
          }
        }.bind(this))
        .catch(function(error) {
          var msg = (error.response && error.response.data && error.response.data.message) || 'Pending 목록 조회 실패';
          this.axiosReqestError('Institution Quota', msg);
        }.bind(this));
    },
    loadInstitutionQuotas: function() {
      var params = {};
      if (this.quotaFilter.username) {
        params.username = this.quotaFilter.username;
      }
      if (this.quotaFilter.institution) {
        params.institution = this.quotaFilter.institution;
      }
      if (this.quotaFilter.status) {
        params.status = this.quotaFilter.status;
      }
      axios.get('/api/admin/institution-quotas', { params: params })
        .then(function(response) {
          if (response.data.success) {
            this.institutionQuotas = response.data.quotas;
            // Initialize openOwners for new owners
            var owners = {};
            for (var i = 0; i < this.institutionQuotas.length; i++) {
              var owner = this.institutionQuotas[i].owner || 'Unknown';
              if (this.openOwners[owner] === undefined) {
                owners[owner] = true;
              }
            }
            for (var k in owners) {
              this.$set(this.openOwners, k, true);
            }
          }
        }.bind(this))
        .catch(function(error) {
          var msg = (error.response && error.response.data && error.response.data.message) || '할당량 목록 조회 실패';
          this.axiosReqestError('Institution Quota', msg);
        }.bind(this));
    },
    setEditQuota: function(quota) {
      this.editQuota.id = quota.id;
      this.editQuota.institution = quota.institution;
      this.editQuota.owner = quota.owner;
      this.editQuota.limit = quota.limit;
      this.editQuota.currentLimit = quota.limit;
      this.editQuota.used = quota.used;
      this.editQuota.expiresAt = quota.expires_at ? quota.expires_at.split('T')[0] : '';
    },
    updateQuota: function() {
      var data = {
        limit: this.editQuota.limit,
        expires_at: this.editQuota.expiresAt
      };
      axios.put('/api/admin/institution-quota/' + this.editQuota.id, data)
        .then(function(response) {
          if (response.data.success) {
            this.$toastr.info('할당량이 업데이트되었습니다', 'Institution Quota');
            var close = document.getElementById('closeEditQuota');
            close.click();
            this.loadInstitutionQuotas();
          }
        }.bind(this))
        .catch(function(error) {
          var msg = (error.response && error.response.data && error.response.data.message) || '업데이트 실패';
          this.axiosReqestError('Institution Quota', msg);
        }.bind(this));
    },
    resetQuotaUsed: function(quota) {
      var yes = confirm(
        '"' + quota.institution + '" (' + quota.owner + ')의 사용량을 초기화하시겠습니까? ' +
        '현재 사용량: ' + quota.used + '/' + quota.limit
      );
      if (!yes) return;
      axios.post('/api/admin/institution-quota/' + quota.id + '/reset')
        .then(function(response) {
          if (response.data.success) {
            this.$toastr.info('사용량이 초기화되었습니다', 'Institution Quota');
            this.loadInstitutionQuotas();
          }
        }.bind(this))
        .catch(function(error) {
          var msg = (error.response && error.response.data && error.response.data.message) || '초기화 실패';
          this.axiosReqestError('Institution Quota', msg);
        }.bind(this));
    },
    toggleQuotaActive: function(quota) {
      var newState = !quota.is_active;
      var action = newState ? '활성화' : '비활성화';
      var yes = confirm(
        '"' + quota.institution + '" (' + quota.owner + ')를 ' + action + '하시겠습니까?'
      );
      if (!yes) return;
      axios.put('/api/admin/institution-quota/' + quota.id, { is_active: newState })
        .then(function(response) {
          if (response.data.success) {
            this.$toastr.info(action + ' 완료', 'Institution Quota');
            this.loadAll();
          }
        }.bind(this))
        .catch(function(error) {
          var msg = (error.response && error.response.data && error.response.data.message) || action + ' 실패';
          this.axiosReqestError('Institution Quota', msg);
        }.bind(this));
    },
    approveQuota: function(quota) {
      var yes = confirm(
        '"' + quota.institution + '" (' + quota.owner + ')을(를) 승인하시겠습니까?'
      );
      if (!yes) return;
      axios.post('/api/admin/institution-quota/' + quota.id + '/approve')
        .then(function(response) {
          if (response.data.success) {
            this.$toastr.info('승인 완료', 'Institution Quota');
            this.loadAll();
          }
        }.bind(this))
        .catch(function(error) {
          var msg = (error.response && error.response.data && error.response.data.message) || '승인 실패';
          this.axiosReqestError('Institution Quota', msg);
        }.bind(this));
    },
    rejectQuota: function(quota) {
      this.rejectForm.quotaId = quota.id;
      this.rejectForm.institution = quota.institution;
      this.rejectForm.owner = quota.owner;
      this.rejectForm.reason = '';
    },
    setRejectPreset: function(preset) {
      this.rejectForm.reason = preset.value;
    },
    confirmReject: function() {
      var reason = this.rejectForm.reason || '';
      axios.post('/api/admin/institution-quota/' + this.rejectForm.quotaId + '/reject', {
        rejection_reason: reason
      })
        .then(function(response) {
          if (response.data.success) {
            this.$toastr.info('거부 완료', 'Institution Quota');
            document.getElementById('closeRejectQuota').click();
            this.loadAll();
          }
        }.bind(this))
        .catch(function(error) {
          var msg = (error.response && error.response.data && error.response.data.message) || '거부 실패';
          this.axiosReqestError('Institution Quota', msg);
        }.bind(this));
    },
    openEditReasonModal: function(quota) {
      this.editReasonForm.quotaId = quota.id;
      this.editReasonForm.institution = quota.institution;
      this.editReasonForm.reason = quota.rejection_reason || '';
    },
    saveEditReason: function() {
      axios.put('/api/admin/institution-quota/' + this.editReasonForm.quotaId, {
        rejection_reason: this.editReasonForm.reason
      })
        .then(function(response) {
          if (response.data.success) {
            this.$toastr.info('거절 사유가 수정되었습니다', 'Institution Quota');
            document.getElementById('closeEditReason').click();
            this.loadAll();
          }
        }.bind(this))
        .catch(function(error) {
          var msg = (error.response && error.response.data && error.response.data.message) || '수정 실패';
          this.axiosReqestError('Institution Quota', msg);
        }.bind(this));
    }
  },
  created: function() {
    this.loadAll();
  }
};
</script>

<style scoped>
.remove-top-border {
  border: none !important;
}
.table th {
  white-space: nowrap;
}
.table td {
  white-space: nowrap;
}
.table-responsive-wrapper {
  overflow-x: auto;
  width: 100%;
}
.fa {
  margin: 0;
  padding: 2px;
  font-size: 16px;
  cursor: pointer;
}
.rejection-reason-text {
  max-width: 150px;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
